/** Helpers compartidos: panel CRM Tareas + modal ficha lead (mismo módulo). */

export const emptyTaskForm = (overrides = {}) => ({
  title: '',
  description: '',
  due_at: '',
  crm_lead_id: '',
  crm_deal_id: '',
  catalog_item_id: '',
  assigned_to_user_id: '',
  activity_label: '',
  function_key: '',
  function_config: {},
  ...overrides,
});

/** ISO → valor datetime-local del browser. */
export function toDatetimeLocalValue(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function taskToForm(task) {
  if (!task) return emptyTaskForm();
  return emptyTaskForm({
    title: task.title || '',
    description: task.description || '',
    due_at: toDatetimeLocalValue(task.due_at) || (task.due_date ? `${task.due_date}T12:00` : ''),
    crm_lead_id: task.crm_lead_id || '',
    crm_deal_id: task.crm_deal_id || '',
    catalog_item_id: task.catalog_item_id || '',
    assigned_to_user_id: task.assigned_to_user_id || '',
    activity_label: task.activity_label || '',
    function_key: task.function_key || '',
    function_config: task.function_config || {},
  });
}

export function formToPayload(form, { leadId } = {}) {
  return {
    title: (form.title || '').trim(),
    description: form.description || null,
    due_at: form.due_at ? new Date(form.due_at).toISOString() : null,
    crm_lead_id: leadId || form.crm_lead_id || null,
    crm_deal_id: form.crm_deal_id || null,
    catalog_item_id: form.catalog_item_id || null,
    assigned_to_user_id: form.assigned_to_user_id || null,
    activity_label: (form.activity_label || form.title || '').trim() || null,
    function_key: form.function_key || null,
    function_config: form.function_config || {},
  };
}

export function validateTaskForm(form) {
  if (!(form.title || '').trim()) return 'Escribe un título';
  if (!form.due_at) return 'Indica fecha y hora (va al calendario del responsable)';
  return null;
}
